import { Trend, type TrendProps } from "@/molecules/Trend"

import type { NumberConvertor } from "@/hooks/useNumberConvertor"

export const TrendCell = (
  converter?:
    NumberConvertor["abbreviateNumber"] | NumberConvertor["intlNumber"],
  currentVariant?: "value" | "percentage"
) =>
  function TrendCellComponent(props: Required<Omit<TrendProps, "variant">>) {
    const { value, percentage = 0 } = props
    const displayValue = converter ? converter(value) : value
    let variant: TrendProps["variant"] = percentage === 0 ? "equal" : undefined

    if (!variant && percentage) variant = percentage > 0 ? "up" : "down"

    const isValueVariant = currentVariant === "value"
    const isPercentageVariant = currentVariant === "percentage"

    return (
      <Trend
        justify={isPercentageVariant ? "flex-start" : "flex-end"}
        variant={variant}
        value={isValueVariant ? displayValue : undefined}
        percentage={isPercentageVariant ? Math.abs(percentage) : undefined}
      />
    )
  }
